// Shared kid-facing copy for animals: emoji + past-tense "moved in" verb by grammatical gender.
export const ANIMAL_EMOJI = { kura: '{chicken}', krowa: '{cow}', pies: '{dog}', kot: '{cat}' };
// Buda names in the accusative — "Kupiono ___", "Postaw ___!"
export const BUDA_ACC = { kurnik: 'kurnik', obora: 'oborę', buda: 'budę', kocie: 'kocie legowisko' };
const SETTLE_VERB = { kura: 'wprowadziła', krowa: 'wprowadziła', pies: 'wprowadził', kot: 'wprowadził' };
// „Kura wprowadziła się! 🐔” / „Pies wprowadził się! 🐶”
export function settleToast(type, namePl) {
  return `${namePl} ${SETTLE_VERB[type] ?? 'wprowadził(a)'} się! ${ANIMAL_EMOJI[type] ?? '{party}'}`;
}
